import(/* webpackMode: "eager" */ "/home/administrador/projetos/bradesco-22-anos/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/administrador/projetos/bradesco-22-anos/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["FrequentlyQuestions"] */ "/home/administrador/projetos/bradesco-22-anos/src/app/componentes/FrequentlyQuestions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavMenu"] */ "/home/administrador/projetos/bradesco-22-anos/src/app/componentes/NavMenu.tsx");
